/*
 * Copyright Notice
 * ================
 * This file contains proprietary information of Discovery Health.
 * Copying or reproduction without prior written approval is prohibited.
 * Copyright (c) 2020.
 */

import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subscription, of } from 'rxjs';
import { skipWhile } from 'rxjs/operators';
import { element } from 'protractor';

@Injectable({
    providedIn: 'root'
})
export class DataShareService {

    subscribe: Array<Subscription> = [];
    public navItems = [];
    obj: Array<any> = [];
    result: boolean;

    permissionSource: BehaviorSubject<Array<any>> = new BehaviorSubject([]);
    permission: Observable<Array<any>> = this.permissionSource.asObservable();

    private routerInfo: BehaviorSubject<Array<any>>;

    emailNotificationFeature: boolean = false;

    constructor() {
        this.routerInfo = new BehaviorSubject<Array<any>>([]);
    }

    getValue(): Observable<Array<any>> {
        return this.permission;
    }

    setValue(newValue): void {
        this.permissionSource.next(newValue);
    }

    getPermissionByPage(pageName: string , keyName: string ): boolean {
        this.obj = [];
        this.result = true;
        this.getValue().pipe(
            skipWhile(item  =>
                 item.length === 0
            )
          ).subscribe(item => {
            // console.log(item);
            this.obj.push(item);
        });
        this.obj.forEach( x => {
            return x.forEach(element1 => {
                if ( element1.children !== undefined && element1.children !== '') {
                    element1.children.forEach( item => {
                        if ( item.name === pageName ) {
                            if (keyName === 'add') {
                                this.result = item.allowAdd;
                            }
                            if (keyName === 'edit') {
                                this.result = item.allowEdit;
                            }
                            if (keyName === 'view') {
                                this.result = item.allowView;
                            }
                        }
                    });
                } else {
                    if (element1.name === pageName) {
                        if (keyName === 'add') {
                            this.result = element1.allowAdd;
                        }
                        if (keyName === 'edit') {
                            this.result = element1.allowEdit;
                        }
                        if (keyName === 'view') {
                            this.result = element1.allowView;
                        }
                    }
                }
            });
        });
        // if (this.obj.length <= 0){
        //     this.result = false;
        // }
        return this.result;
    }
}
